//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface AddConversationAttachment {
  filename: string;
}

export interface Address {
  line1: string;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  locality: string | null;
  region: string | null;
  postcode: string;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  source: string | null;
}

export interface AssetVirtualPathInfo {
  path: string;
  hash: string | null;
  size: number | null;
  publicUrl: string | null;
  lastModifiedUtc: string | null;
}

export interface AttachedBlobAsset {
  assetPath: string;
  data: string | null;
  dataBase64: string | null;
  delete: boolean;
  readonly hasContent: boolean;
}

export interface BinaryDataWrapper {
  data: string | null;
}

export interface Branch {
  dateCreated: string;
  id: string;
  recordVersion: string;
  franchiseeId: string;
  taxRegistrationNumber: string | null;
  abbreviation: string;
  name: string;
  physicalAddress: Address;
  billingAddress: Address | null;
  physicalAddressAsDefaultShipping: boolean;
  shippingNotes: string | null;
  hidden: boolean;
}

export interface BranchInboxAttachment {
  displayName: string;
  virtualPath: string;
}

export interface BranchInboxAttachments {
  items: BranchInboxAttachment[];
}

export interface BranchInboxItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  subject: string;
  branchId: string;
  message: string;
  attachments: BranchInboxAttachments;
  navigation: BranchInboxNavigation;
}

export enum BranchInboxItemState {
  Unread = 0,
  Pinned = 1,
  Read = 2,
  Hidden = 4
}

export interface BranchInboxNavigation {
  items: UINavigation[];
}

export interface BranchQuote {
  dateCreated: string;
  id: string;
  recordVersion: string;
  branchId: string;
  globalSupplierSupplierId: string;
  quoteSetId: string;
  clientId: string;
  clientName: string | null;
  contactId: string;
  contactName: string | null;
  clientTypeId: string;
  clientTypeName: string | null;
  lockForFabrication: boolean;
}

export interface BranchQuoteDefaults {
  dateCreated: string;
  id: string;
  recordVersion: string;
  branchId: string;
  templateName: string;
  systemUserId: string;
  supplierId: string;
  data: string;
}

export interface BranchQuoteDefaultsPrimary {
  dateCreated: string;
  id: string;
  recordVersion: string;
  branchId: string;
  supplierId: string;
  branchQuoteDefaultsId: string;
  systemUserId: string;
}

export interface BranchQuoteSupport {
  dateCreated: string;
  id: string;
  recordVersion: string;
  subject: string;
  branchQuoteId: string;
  conversationId: string;
  status: BranchQuoteSupportStatus;
  type: BranchQuoteSupportItemType;
  lastModified: string;
  lastModifiedUserId: string;
  createdUserId: string;
  masterDocumentConversationId: string | null;
  assignedSupplierUserId: string | null;
  quoteItemLink: { [key: string]: SupportQuoteItemLinkDetail } | null;
}

export enum BranchQuoteSupportItemType {
  All = 0,
  Basic = 1,
  QuoteReview = 2,
  EngineeredToOrder = 4,
  QuoteAssistanceRequest = 8
}

export enum BranchQuoteSupportStatus {
  All = 0,
  New = 1,
  Overdue = 2,
  Active = 4,
  Resolved = 8,
  Cancelled = 16,
  ReActivated = 32,
  Draft = 64,
  Deleted = 128
}

export interface BuyInStockItem {
  supplierId: string;
  code: string;
  description: string;
  resourceType: number;
  libCode: string;
  supplierCode: string;
}

export interface CSVProducerData {
  fileName: string;
  columns: string[];
  rows: { [key: string]: any }[];
}

export interface Client {
  dateCreated: string;
  id: string;
  recordVersion: string;
  name: string;
  businessPhoneNumber: string;
  physicalAddress: Address;
  shippingNotes: string | null;
  shipToPhysicalAddress: boolean;
  billingAddress: Address | null;
  externalProvidedDataId: string | null;
  clientOwnerId: string;
  state: ClientState;
}

export interface ClientPrimaryContact {
  dateCreated: string;
  id: string;
  recordVersion: string;
  clientId: string;
  contactId: string | null;
}

export enum ClientState {
  Active = 0,
  Archived = 1
}

export interface ConnectedState {
  connected: boolean;
}

export interface Contact {
  dateCreated: string;
  id: string;
  recordVersion: string;
  name: string;
  title: string | null;
  email: string;
  mobile: string | null;
  clientId: string;
}

export enum CurrencyCode {
  ALL = 8,
  DZD = 12,
  ARS = 32,
  AUD = 36,
  BSD = 44,
  BHD = 48,
  BDT = 50,
  AMD = 51,
  BBD = 52,
  BMD = 60,
  BTN = 64,
  BOB = 68,
  BWP = 72,
  BZD = 84,
  SBD = 90,
  BND = 96,
  MMK = 104,
  BIF = 108,
  KHR = 116,
  CAD = 124,
  CVE = 132,
  KYD = 136,
  LKR = 144,
  CLP = 152,
  CNY = 156,
  COP = 170,
  KMF = 174,
  CRC = 188,
  HRK = 191,
  CUP = 192,
  CZK = 203,
  DKK = 208,
  DOP = 214,
  SVC = 222,
  ETB = 230,
  ERN = 232,
  FKP = 238,
  FJD = 242,
  DJF = 262,
  GMD = 270,
  GIP = 292,
  GTQ = 320,
  GNF = 324,
  GYD = 328,
  HTG = 332,
  HNL = 340,
  HKD = 344,
  HUF = 348,
  ISK = 352,
  INR = 356,
  IDR = 360,
  IRR = 364,
  IQD = 368,
  ILS = 376,
  JMD = 388,
  JPY = 392,
  KZT = 398,
  JOD = 400,
  KES = 404,
  KPW = 408,
  KRW = 410,
  KWD = 414,
  KGS = 417,
  LAK = 418,
  LBP = 422,
  LSL = 426,
  LRD = 430,
  LYD = 434,
  MOP = 446,
  MWK = 454,
  MYR = 458,
  MVR = 462,
  MUR = 480,
  MXN = 484,
  MNT = 496,
  MDL = 498,
  MAD = 504,
  OMR = 512,
  NAD = 516,
  NPR = 524,
  ANG = 532,
  AWG = 533,
  VUV = 548,
  NZD = 554,
  NIO = 558,
  NGN = 566,
  NOK = 578,
  PKR = 586,
  PAB = 590,
  PGK = 598,
  PYG = 600,
  PEN = 604,
  PHP = 608,
  QAR = 634,
  RUB = 643,
  RWF = 646,
  SHP = 654,
  SAR = 682,
  SCR = 690,
  SLL = 694,
  SGD = 702,
  VND = 704,
  SOS = 706,
  ZAR = 710,
  SSP = 728,
  SZL = 748,
  SEK = 752,
  CHF = 756,
  SYP = 760,
  THB = 764,
  TOP = 776,
  TTD = 780,
  AED = 784,
  TND = 788,
  UGX = 800,
  MKD = 807,
  EGP = 818,
  GBP = 826,
  TZS = 834,
  USD = 840,
  UYU = 858,
  UZS = 860,
  WST = 882,
  YER = 886,
  TWD = 901,
  SLE = 925,
  VES = 928,
  MRU = 929,
  STN = 930,
  ZWL = 932,
  BYN = 933,
  TMT = 934,
  GHS = 936,
  SDG = 938,
  RSD = 941,
  MZN = 943,
  AZN = 944,
  RON = 946,
  TRY = 949,
  XAF = 950,
  XCD = 951,
  XOF = 952,
  XPF = 953,
  XBA = 955,
  XBB = 956,
  XBC = 957,
  XBD = 958,
  XAU = 959,
  XDR = 960,
  XAG = 961,
  XPT = 962,
  XTS = 963,
  XPD = 964,
  XUA = 965,
  ZMW = 967,
  SRD = 968,
  MGA = 969,
  AFN = 971,
  TJS = 972,
  AOA = 973,
  BGN = 975,
  CDF = 976,
  BAM = 977,
  EUR = 978,
  UAH = 980,
  GEL = 981,
  PLN = 985,
  BRL = 986,
  XSU = 994,
  XXX = 999
}

export interface DealerProblemDetails {}

export interface DealerQuotePriceAdjustment {
  title: string | null;
  description: string | null;
  comment: string | null;
  adjustmentMethod: DealerQuotePriceAdjustmentMethod;
  adjustmentValue: number;
  isTaxable: boolean;
}

export enum DealerQuotePriceAdjustmentMethod {
  PriceAdjustment = 0,
  SubtotalAdjustment = 1,
  TotalAdjustment = 2
}

export enum DealerReport {
  ReportA = 0,
  ReportB = 1,
  ReportC = 2,
  ReportD = 3,
  ReportDD = 4,
  ReportE = 5,
  ReportF = 6,
  ReportG = 7,
  ReportH = 8,
  ReportI = 9,
  ReportJ = 10,
  QuoteDataExportJson = 11,
  QuoteDataExportXml = 12,
  PurchaseOrderDataExportJson = 13,
  PurchaseOrderDataExportXml = 14
}

export enum DeleteMode {
  SoftDelete = 0,
  HardDelete = 1,
  UnDelete = 2
}

export enum DocumentCategory {
  All = 0,
  Permanent = 1,
  Temporary = 2
}

export enum DocumentState {
  All = 0,
  Pending = 1,
  Available = 2,
  Failed = 4,
  Deleted = 8
}

export enum DocumentSubType {
  CAD = 1,
  Legal = 2,
  TechnicalNotes = 3,
  QuoteShopDrawing = 1000,
  DealerQuotePDF = 1001,
  ClientQuotePDF = 1002,
  ClientQuoteAPDF = 1003,
  ClientQuoteBNoItemPricePDF = 1004,
  ClientQuoteCNoItemPriceNoDimPDF = 1005,
  DealerQuoteEIternalPDF = 1006,
  ClientQuoteGNoPricePDF = 1007,
  DealerQuoteHIternalPDF = 1008,
  DealerQuoteDataExportJson = 1009,
  ClientQuoteSummaryPDF = 1010,
  DealerQuoteDataExportXml = 1011,
  PurchaseOrderPDF = 2000,
  PurchaseOrderDPDF = 2001,
  PurchaseOrderDDPDF = 2002,
  PurchaseOrderDataExportJson = 2003,
  PurchaseOrderDataExportXml = 2004,
  CuttingPlan = 3000
}

export interface DocumentTracker {
  dateCreated: string;
  id: string;
  recordVersion: string;
  projectId: string;
  resourceId: string;
  resourceType: ResourceType;
  virtualFilePath: string;
  description: string;
  category: DocumentCategory;
  subType: DocumentSubType;
  state: DocumentState;
}

export interface ExternalProviderDefinition {
  referenceId: string;
  service: string;
  data: string;
}

export interface FabricationJob {
  dateCreated: string;
  id: string;
  recordVersion: string;
  jobNumber: number;
  title: string;
  description: string;
  state: FabricationJobState;
  branchId: string;
  creationUserId: string;
  lastModifiedUserId: string | null;
  lastModifiedDate: string;
  assignedToUserId: string;
}

export interface FabricationJobItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  fabricationJobId: string;
  quoteItemId: string;
  unitOverrides: UnitOptionOverride[] | null;
  baselineV6QuoteItemVirtualPath: string | null;
  baselineBomVirtualPath: string | null;
}

export enum FabricationJobState {
  Draft = 1,
  Planned = 2,
  AwaitingOrder = 3,
  ReadyForProduction = 4,
  InProduction = 5,
  Completed = 6
}

export interface FabricationJobStateCount {
  state: FabricationJobState;
  count: number;
}

export interface FabricationJobSummaryView {
  id: string;
  recordVersion: string;
  jobNumber: number;
  title: string;
  state: FabricationJobState;
  itemCount: number;
  distinctQuoteItemIds: string[];
  dateCreated: string;
  lastModifiedDate: string | null;
  assignedToUserId: string;
}

export interface FabricationJobSummaryViewResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: FabricationJobSummaryView[];
}

export interface FabricationPurchaseOrder {
  dateCreated: string;
  id: string;
  recordVersion: string;
  purchaseOrderNumber: number;
  title: string;
  description: string;
  state: FabricationPurchaseOrderState;
  supplierId: string;
  branchId: string;
  creationUserId: string;
  lastModifiedUserId: string | null;
  lastModifiedDate: string;
  assignedToUserId: string;
  reference: string;
  quoteCommonId: string | null;
  supplierSystemStatus: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemClosedDate: string | null;
  supplierSystemNotesToDealer: string | null;
  supplierSystemShippingLeadTime: number | null;
  supplierSystemLastModifiedDate: string | null;
  calculatedNetTotal: number;
  purchaseOrderCurrency: string;
}

export interface FabricationPurchaseOrderItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  fabricationPurchaseOrderId: string;
  itemType: PurchaseItemType;
  libraryCode: string;
  code: string;
  finish: string;
  finishLibraryCode: string;
  resourceDescription: string;
  finishDescription: string;
  barLength: number | null;
  barLengthDisplay: string | null;
  width: number | null;
  widthDisplay: string | null;
  height: number | null;
  heightDisplay: string | null;
  quantity: number;
  quantityDisplay: string | null;
  source: PurchaseOrderItemSource;
  packSize: number | null;
  rollLength: number | null;
  rollLengthDisplay: string | null;
  netSellPrice: number;
}

export interface FabricationPurchaseOrderLinePrice {
  itemId: string;
  netSellPrice: number;
}

export interface FabricationPurchaseOrderQuoteInfo {
  purchaseOrderId: string;
  quoteCommonId: string;
}

export enum FabricationPurchaseOrderState {
  Draft = 1,
  Issued = 2,
  Completed = 3,
  Cancelled = 4,
  IssuedPending = 5
}

export interface FabricationPurchaseOrderStateCount {
  state: FabricationPurchaseOrderState;
  count: number;
}

export interface FabricationPurchaseOrderSupplierInfo {
  purchaseOrderId: string;
  reference: string;
  supplierSystemDeliveryDate: string | null;
  supplierSystemClosedDate: string | null;
  supplierSystemNotesToDealer: string | null;
  supplierSystemStatus: string | null;
  supplierSystemShippingLeadTime: number | null;
}

export interface Franchisee {
  dateCreated: string;
  id: string;
  recordVersion: string;
  tenantId: number;
  taxRegistrationNumber: string | null;
  name: string;
  positiveLogoVirtualPath: string | null;
  negativeLogoVirtualPath: string | null;
  properties: { [key: string]: string };
}

export interface FranchiseeClient {
  dateCreated: string;
  id: string;
  recordVersion: string;
  paymentProfileId: string | null;
  termsAndConditionsId: string | null;
  externalCustomerReference: string | null;
}

export interface FranchiseeConfiguration {
  dateCreated: string;
  id: string;
  recordVersion: string;
  quoteType: QuoteType;
  allowNonTaxableItems: boolean;
}

export interface InitialPriceDefinition {
  singleUnitCost: number;
  supplierPriceAdjustment: number;
  supplierPriceAdjustmentEnabled: boolean;
  supplierPriceAdjustmentReason: string | null;
  supplierGrossSingleUnitCost: number;
  supplierNettSingleUnitCost: number;
  sourceData: { [key: string]: number };
  breakdowns: QuoteItemPriceBreakdown[] | null;
}

export interface InputAddBranchInboxItem {
  branchId: string;
  subject: string;
  message: string;
  attachments: BranchInboxAttachments;
  navigation: BranchInboxNavigation;
}

export interface InputAddBranchQuoteSupport {
  id: string;
  conversationId: string | null;
  subject: string;
  branchQuoteId: string;
  status: BranchQuoteSupportStatus;
  type: BranchQuoteSupportItemType;
  conversationEntry: InputFirstConversationEntry | null;
  masterDocumentConversationEntry: InputFirstConversationEntry | null;
  quoteItemLink: { [key: string]: SupportQuoteItemLinkDetail } | null;
}

export interface InputAddJobToPurchaseOrder {
  purchaseOrderId: string;
  recordVersion: string;
  fabricationJobId: string;
}

export interface InputAddManualLineToPurchaseOrder {
  purchaseOrderId: string;
  recordVersion: string;
  itemType: PurchaseItemType;
  libraryCode: string;
  code: string;
  finish: string;
  finishLibraryCode: string;
  resourceDescription: string;
  finishDescription: string;
  quantity: number;
  notOrder: boolean;
  barLength: number | null;
  barLengthDisplay: string | null;
  width: number | null;
  widthDisplay: string | null;
  height: number | null;
  heightDisplay: string | null;
  packSize: number | null;
  rollLength: number | null;
  rollLengthDisplay: string | null;
}

export interface InputAddQuoteItemToFabricationJob {
  fabricationJobId: string;
  quoteItemId: string;
  fabricationJobRecordVersion: string;
}

export interface InputBoundConversationEntry {
  id: string;
  text: string;
  attachments: AddConversationAttachment[];
  users: string[];
  draft: boolean;
}

export interface InputBranchQuoteDefault {
  id: string;
  branchId: string;
  templateName: string;
  systemUserId: string;
  supplierId: string;
  data: string;
}

export interface InputCSVProducer {
  data: CSVProducerData[];
  fileName: string;
}

export interface InputCancelPurchaseOrder {
  id: string;
  recordVersion: string;
}

export interface InputCleanupConversationAttachments {
  conversationId: string;
  conversationEntryId: string;
}

export interface InputCleanupQuoteFabricationData {
  quoteId: string;
  quoteItemIds: string[];
}

export interface InputCompleteOptimization {
  fabricationJobId: string;
  jobContentHash: string;
  optimizationRunId: string;
  resultBlobPath: string;
  cuttingPlanPdfPath: string;
  cutplanCount: number;
  totalBarCount: number;
  totalBarLength: number;
  totalBarLengthDisplay: string;
  totalExtrusionLength: number;
}

export interface InputCopyFileItem {
  originalVirtualPath: string;
  copyVirtualPath: string;
}

export interface InputCopyFilesByVirtualPath {
  copyData: InputCopyFileItem[];
}

export interface InputCreateBranch {
  id: string | null;
  taxRegistrationNumber: string | null;
  name: string;
  abbreviation: string;
  physicalAddress: Address;
  billingAddress: Address | null;
  physicalAddressAsDefaultShipping: boolean;
  shippingNotes: string | null;
}

export interface InputCreateBranchQuote {
  branchQuote: BranchQuote;
}

export interface InputCreateBuyIn {
  tenantId: number;
  buyInStockItems: BuyInStockItem[];
}

export interface InputCreateClient {
  client: Client;
}

export interface InputCreateContact {
  contact: Contact;
  isPrimary: boolean;
}

export interface InputCreateEmptyPurchaseOrder {
  branchId: string;
  supplierId: string;
  title: string;
  description: string;
}

export interface InputCreateFabricationJob {
  id: string | null;
  branchId: string;
  title: string;
  description: string;
}

export interface InputCreateFranchiseeClient {
  id: string;
  paymentProfileId: string | null;
  termsAndConditionsId: string | null;
  externalCustomerReference: string | null;
}

export interface InputCreatePaymentProfile {
  paymentProfile: PaymentProfile;
}

export interface InputCreateProject {
  project: Project;
  projectReferences: ProjectResourceReference[] | null;
  numberSeed: string;
}

export interface InputCreateProjectDocumentLink {
  links: InputDocumentLink[];
}

export interface InputCreateProjectResourceReference {
  projectId: string;
  resourceId: string;
  typeOf: ResourceType;
  parentTypeOf: ResourceType;
  parentResourceId: string;
}

export interface InputCreatePurchaseOrder {
  purchaseOrder: PurchaseOrder;
  lineItems: InputLineItem[];
  batches: PurchaseOrderBatchInput[] | null;
  numberSeed: string;
}

export interface InputCreatePurchaseOrderFromJobs {
  branchId: string;
  supplierId: string;
  title: string;
  description: string;
  fabricationJobIds: string[];
}

export interface InputCreateQuote {
  quoteOwnerId: string;
  supplierId: string;
  id: string | null;
  title: string | null;
  validUntilDate: string | null;
  termsAndConditions: string;
  quoteType: QuoteType;
  shippingTitle: string | null;
  shippingDescription: string | null;
  serviceProvider: string;
  serviceProviderData: string | null;
  assets: { [key: string]: AttachedBlobAsset };
  taxPercentage: number;
  excludeShippingLineItem: boolean | null;
  allowNonTaxableItems: boolean | null;
  quoteCurrency: CurrencyCode;
}

export interface InputCreateQuoteItem {
  quoteId: string;
  quoteItemId: string;
  title: string | null;
  description: string | null;
  quantity: number | null;
  comment: string | null;
  commentToManufacturer: string | null;
  assets: { [key: string]: AttachedBlobAsset };
  externalProvider: ExternalProviderDefinition | null;
  buyInData: BinaryDataWrapper | null;
  price: InitialPriceDefinition | null;
  quoteItemContentType: number;
  isRestrictedToPowerUser: boolean | null;
  isTaxableItem: boolean | null;
}

export interface InputCreateQuoteItemFabrications {
  quoteId: string;
  quoteItemIds: string[];
}

export interface InputCreateTempPurchaseOrderQuote {
  quoteId: string;
  branchId: string;
}

export interface InputCreateTermsAndConditions {
  termsAndConditions: TermsAndConditions;
}

export interface InputDeleteBranch {
  branchId: string;
  recordVersion: string;
}

export interface InputDeleteBranchQuote {
  branchQuoteId: string;
}

export interface InputDeleteDraftBranchQuoteSupport {
  branchQuoteSupportId: string;
}

export interface InputDeleteFabricationJob {
  id: string;
  recordVersion: string;
}

export interface InputDeleteFileItem {
  virtualPath: string;
}

export interface InputDeleteFilesByVirtualPath {
  fileItems: InputDeleteFileItem[];
}

export interface InputDeletePaymentProfile {
  paymentProfileId: string;
  recordVersion: string;
}

export interface InputDeleteProject {
  projectId: string;
  recordVersion: string;
}

export interface InputDeleteProjectDocument {
  id: string;
}

export interface InputDeleteProjectResourceReference {
  projectId: string;
  resourceId: string;
}

export interface InputDeleteQuote {
  quoteId: string;
  reason: string | null;
}

export interface InputDeleteQuoteItem {
  quoteItemId: string;
  deleteMode: DeleteMode | null;
}

export interface InputDocumentLink {
  id: string | null;
  projectId: string;
  resourceId: string;
  resourceType: ResourceType;
  virtualFilePath: string;
  description: string;
  category: DocumentCategory;
  state: DocumentState;
  subType: DocumentSubType;
}

export interface InputDuplicateBranchQuoteSupport {
  branchQuoteSupportId: string;
  originalQuoteItemId: string;
  branchQuoteId: string;
  quoteItemId: string;
  quoteItemConversationType: QuoteItemConversationType | null;
  status: BranchQuoteSupportStatus | null;
  conversationEntries: InputBoundConversationEntry[] | null;
}

export interface InputDuplicateConversation {
  conversationId: string;
  newConversationId: string;
  conversationEntries: InputBoundConversationEntry[] | null;
}

export interface InputDuplicateQuote {
  quoteId: string;
  validUntilDate: string;
  asAlternate: boolean;
  alternativeType: QuoteAlternativeType;
  numberSeed: string | null;
  title: string | null;
  quoteState: QuoteState | null;
  quoteCustomerId: string | null;
  excludedQuoteItems: string[] | null;
  clearShippingAddress: boolean;
  sessionLock: string;
}

export interface InputDuplicateQuoteItem {
  quoteItemId: string;
}

export interface InputEditConversationEntry {
  id: string;
  text: string;
  draft: boolean;
  deleteEntry: boolean;
  forceUpdate: boolean;
  attachments: AddConversationAttachment[] | null;
  users: string[] | null;
}

export interface InputFailOptimization {
  fabricationJobId: string;
  errorMessage: string;
  optimizationRunId: string;
}

export interface InputFirstConversationEntry {
  id: string;
  text: string;
  attachments: AddConversationAttachment[];
  users: string[];
  draft: boolean;
}

export interface InputGenerateQuoteReport {
  quoteId: string;
  isInternalReport: boolean;
}

export interface InputGenerateReport {
  id: string;
  dealerReport: DealerReport;
}

export interface InputGetActiveUserInformation {
  systemUserId: string;
}

export interface InputGetConcurrencyCheck {
  id: string;
  objectType: string;
}

export interface InputInvalidateOptimization {
  fabricationJobId: string;
  optimizationResultRecordVersion: string;
}

export interface InputIssueFabricationPurchaseOrder {
  purchaseOrderId: string;
  recordVersion: string;
}

export interface InputIssuePurchaseOrder {
  quoteId: string;
  branchId: string;
  projectId: string;
  purchaseOrderId: string;
}

export interface InputIssueQuote {
  quoteId: string;
  branchId: string;
  projectId: string;
}

export interface InputLapseQuotes {
  tenantId: number | null;
  cutOffDate: string;
}

export interface InputLineItem {
  id: string;
  grossQuantityCost: number;
  grossSupplierQuantityCost: number;
  supplierPriceAdjustment: number;
  quoteItemBatchId: string | null;
  quoteItemBatchPosition: number | null;
}

export interface InputLockInOptimization {
  fabricationJobId: string;
  recordVersion: string;
  optimizationResultRecordVersion: string;
}

export interface InputLockResource {
  sessionLock: string;
  resourceId: string;
  resourceType: string | null;
}

export interface InputLockResources {
  locks: InputLockResource[];
}

export interface InputPreviewQuoteShopDrawing {
  branchId: string;
  projectId: string;
  quoteId: string;
}

export interface InputQueueCleanupConversationAttachments {
  conversationId: string;
  conversationEntryId: string;
}

export interface InputQuoteCleanupDeletedItems {
  quoteId: string;
}

export interface InputQuoteItemConversation {
  quoteId: string;
  quoteItemId: string;
  type: QuoteItemConversationType;
  conversationId: string | null;
}

export interface InputQuoteItemConversations {
  quoteItemIds: string[];
}

export interface InputQuoteState {
  quoteId: string;
  state: QuoteState;
  stateChangeReason: InputUpdateQuoteStateChangeReason | null;
  expectedCurrentState: QuoteState | null;
}

export interface InputRecordQuoteItemDelivery {
  quoteItemIds: string[];
  deliveryDate: string;
  notes: string;
}

export interface InputRegisterFabricationJobOnProject {
  projectId: string;
  fabricationJobId: string;
  cuttingPlanPdfPath: string;
  cuttingPlanDescription: string;
}

export interface InputReleaseCopyLock {
  sourceQuoteId: string;
  operationLockOwner: string;
}

export interface InputRemovePurchaseOrderLine {
  purchaseOrderId: string;
  recordVersion: string;
  itemId: string;
}

export interface InputRemoveQuoteItemFromFabricationJob {
  fabricationJobId: string;
  quoteItemId: string;
  fabricationJobRecordVersion: string;
}

export interface InputResetQuoteFromIssuePending {
  quoteId: string;
}

export interface InputResolveBranchQuoteSupport {
  quoteSetId: string;
  resolutionReason: string;
}

export interface InputRevertFabricationPurchaseOrderToDraft {
  purchaseOrderId: string;
  quoteCommonId: string | null;
  supplierQuoteMayExist: boolean;
}

export interface InputSetFabricationPurchaseOrderIssued {
  purchaseOrderId: string;
  reference: string;
  quoteCommonId: string;
  calculatedNetTotal: number;
  purchaseOrderCurrency: string;
  supplierSystemDeliveryDate: string | null;
  supplierSystemShippingLeadTime: number | null;
  supplierSystemStatus: string | null;
  linePrices: FabricationPurchaseOrderLinePrice[];
}

export interface InputSetQuoteAssignedToUser {
  userId: string;
  quoteIds: string[];
}

export interface InputSetQuoteItemFactoryTrackingReference {
  quoteItemId: string;
  reference: string;
}

export interface InputStartOptimization {
  fabricationJobId: string;
  customKerfStraight: number;
  customKerfAngle: number;
}

export interface InputTransitionFabricationJobState {
  fabricationJobId: string;
  targetState: FabricationJobState;
  recordVersion: string;
}

export interface InputUnLockResource {
  sessionLock: string;
  resourceId: string;
}

export interface InputUnLockResources {
  locks: InputUnLockResource[];
}

export interface InputUnitOverride {
  unitIndex: number;
  v6QuoteItemJson: string | null;
  bomJson: string | null;
}

export interface InputUnregisterFabricationJobFromProject {
  projectId: string;
  fabricationJobId: string;
}

export interface InputUpdateBranch {
  branch: Branch;
}

export interface InputUpdateBranchQuote {
  branchQuote: BranchQuote;
}

export interface InputUpdateBranchQuoteDefaults {
  branchQuoteDefaults: InputBranchQuoteDefault;
  isPrimary: boolean | null;
}

export interface InputUpdateBranchQuoteSupport {
  branchQuoteSupportId: string;
  conversationId: string | null;
  branchQuoteId: string | null;
  subject: string | null;
  quoteItemIdToDetach: string | null;
  status: BranchQuoteSupportStatus | null;
  assignedSupplierUserId: string | null;
  newConversationEntries: InputBoundConversationEntry[] | null;
  editConversationEntries: InputEditConversationEntry[] | null;
  quoteItemLink: { [key: string]: SupportQuoteItemLinkDetail } | null;
  notifySupplier: boolean | null;
}

export interface InputUpdateClient {
  client: Client;
}

export interface InputUpdateClientDefaults {
  clientId: string;
  primaryProfileId: string | null;
  termsAndConditionsId: string | null;
  rowVersion: string | null;
}

export interface InputUpdateContact {
  contact: Contact;
  isPrimary: boolean;
}

export interface InputUpdateFabricationJob {
  id: string;
  recordVersion: string;
  title: string;
  description: string;
  assignedToUserId: string;
}

export interface InputUpdateFabricationJobItemUnitOverrides {
  fabricationJobItemId: string;
  fabricationJobRecordVersion: string;
  unitOverrides: InputUnitOverride[];
  pristineV6QuoteItemJson: string | null;
  pristineBomJson: string | null;
}

export interface InputUpdateFabricatorRateOverrides {
  supplierId: string;
  overrides: LaborRateOverrides;
}

export interface InputUpdateFileByVirtualPath {
  oldVirtualPath: string;
  newVirtualPath: string;
  data: string;
}

export interface InputUpdateFranchisee {
  franchisee: Franchisee | null;
}

export interface InputUpdateFranchiseeConfiguration {
  franchiseeConfiguration: FranchiseeConfiguration;
  taxRates: TaxRate[];
}

export interface InputUpdateFranchiseeProperties {
  properties: { [key: string]: string };
}

export interface InputUpdatePaymentProfile {
  paymentProfile: PaymentProfile;
}

export interface InputUpdateProject {
  project: Project;
  stateChangeReason: InputUpdateProjectStateChangeReason | null;
}

export interface InputUpdateProjectDocumentLink {
  links: DocumentTracker[];
}

export interface InputUpdateProjectStateChangeReason {
  finalStateReason: ProjectFinalStateReason;
  comment: string;
}

export interface InputUpdatePurchaseOrder {
  purchaseOrder: PurchaseOrder;
  stateChangeReason: InputUpdatePurchaseOrderStateChangeReason | null;
}

export interface InputUpdatePurchaseOrderHeader {
  id: string;
  recordVersion: string;
  title: string;
  description: string;
}

export interface InputUpdatePurchaseOrderLineQuantity {
  purchaseOrderId: string;
  recordVersion: string;
  itemId: string;
  quantity: number;
}

export interface InputUpdatePurchaseOrderStateChangeReason {
  finalStateReason: PurchaseOrderFinalStateReason;
  comment: string;
}

export interface InputUpdateQuote {
  assets: { [key: string]: AttachedBlobAsset } | null;
  siblingQuoteState: InputQuoteState[] | null;
  quote: Quote | null;
  quotePrice: QuotePrice | null;
  numberSeed: string | null;
  stateChangeReason: InputUpdateQuoteStateChangeReason | null;
  quotePresentation: QuotePresentation | null;
  providerDataDifference: string | null;
  batches: QuoteItemBatchInput[] | null;
  itemBatchAssignments: { [key: string]: string } | null;
}

export interface InputUpdateQuoteItem {
  assets: { [key: string]: AttachedBlobAsset } | null;
  quoteItem: QuoteItem;
  providerDataDifference: string | null;
  quoteItemBuyInData: BinaryDataWrapper | null;
  quoteItemPrice: QuoteItemPrice | null;
}

export interface InputUpdateQuoteItems {
  items: UpdateQuoteItem[];
}

export interface InputUpdateQuotePrice {
  quotePrice: QuotePrice;
  dealerQuotePriceAdjustment: DealerQuotePriceAdjustment;
  quoteItems: QuoteItem[] | null;
  quoteItemPrices: QuoteItemPrice[] | null;
  commitChanges: boolean;
}

export interface InputUpdateQuoteSetState {
  quoteState: InputQuoteState[];
}

export interface InputUpdateQuoteStateChangeReason {
  finalStateReason: QuoteFinalStateReason;
  comment: string;
}

export interface InputUpdateStock {
  stock: StockItem[];
}

export interface InputUpdateTermsAndConditions {
  termsAndConditions: TermsAndConditions;
}

export enum ItemSummaryLayout {
  Compact = 0,
  Detailed = 1
}

export interface JobPurchaseOrderBadgesView {
  fabricationJobId: string;
  badges: PurchaseOrderBadgeView[];
}

export interface LaborRateGridLibrary {
  libraryCode: string;
  libraryDescription: string;
  areas: string[];
  types: string[];
  layers: string[];
  rates: string[][][];
  factors: string[][][];
}

export interface LaborRateOverrides {
  libraries: LaborRateGridLibrary[];
}

export interface LookupStockItem {
  supplierId: string;
  code: string;
  libCode: string;
  supplierCode: string;
}

export interface OptimizationContextItem {
  quoteItemId: string;
  quantity: number;
  bomVirtualPath: string | null;
}

export interface OptimizationResult {
  dateCreated: string;
  id: string;
  recordVersion: string;
  state: OptimizationState;
  errorMessage: string | null;
  resultBlobPath: string | null;
  cuttingPlanPdfPath: string | null;
  jobContentHash: string;
  optimizationRunId: string;
  lastRunStartedAt: string;
  cutplanCount: number | null;
  totalBarCount: number | null;
  totalBarLength: number | null;
  totalBarLengthDisplay: string | null;
  totalExtrusionLength: number | null;
}

export enum OptimizationState {
  Idle = 0,
  InProgress = 1,
  Completed = 2,
  Failed = 3
}

export interface PaymentProfile {
  dateCreated: string;
  id: string;
  recordVersion: string;
  franchiseeId: string;
  branchId: string;
  name: string;
  value: number;
  discount: number | null;
  supplierId: string;
  calculation: PaymentProfileCalculation;
}

export enum PaymentProfileCalculation {
  Margin = 1,
  Markup = 2
}

export interface PaymentProfileSummary {
  id: string;
  name: string;
  value: number;
  discount: number | null;
  supplierId: string;
  calculation: PaymentProfileCalculation;
}

export interface PaymentProfileSummaryResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: PaymentProfileSummary[];
}

export interface PricingRule {
  id: string;
  supplierId: number;
  name: string;
  ruleTypeId: string;
  minValue: number;
  maxValue: number;
  minMarkup: number;
  maxMarkup: number;
}

export interface PricingRuleType {
  id: string;
  name: string;
  hasMinMax: boolean;
}

export interface Project {
  dateCreated: string;
  id: string;
  recordVersion: string;
  title: string;
  number: number;
  clientId: string;
  contactId: string;
  clientTypeId: string;
  termsAndConditionsId: string | null;
  state: ProjectState;
  budget: number | null;
  description: string | null;
  defaultAddress: Address;
  shipToDefaultAddress: boolean;
  shippingNotes: string | null;
  creationUserId: string;
  lastModifiedUserId: string;
  lastModifiedDate: string;
  projectOwnerId: string;
  assignedToUserId: string;
}

export enum ProjectFinalStateReason {
  None = 0,
  Deadline = 1,
  CompetitorWin = 2,
  UnresponsiveClient = 4,
  IndecisiveClient = 8,
  UnhappyClient = 16,
  DifficultClient = 32,
  Superseded = 64,
  Other = 128
}

export interface ProjectResourceReference {
  resourceId: string;
  typeOf: ResourceType;
  parentTypeOf: ResourceType;
  parentResourceId: string;
}

export enum ProjectState {
  None = 0,
  Active = 1,
  Cancelled = 2,
  Completed = 4
}

export enum PurchaseItemType {
  Extrusion = 1,
  Component = 2,
  Gasket = 3,
  Fill = 4
}

export interface PurchaseOrder {
  dateCreated: string;
  id: string;
  recordVersion: string;
  title: string;
  purchaseOrderNumber: number;
  branchQuoteId: string;
  state: PurchaseOrderState;
  description: string;
  installationDate: string | null;
  creationUserId: string;
  lastModifiedUserId: string;
  lastModifiedDate: string | null;
  assignedToUserId: string;
  reference: string;
  customPurchaseOrderNumber: string | null;
  supplierId: string;
  supplierSystemLastModifiedDate: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemClosedDate: string | null;
  supplierSystemStatus: string | null;
  supplierSystemShippingLeadTime: number | null;
  purchaseOrderCurrency: CurrencyCode;
  calculatedNetTotal: number;
  calculatedAdjustmentTotal: number;
}

export interface PurchaseOrderBadgeView {
  id: string;
  purchaseOrderNumber: number;
  state: FabricationPurchaseOrderState;
}

export interface PurchaseOrderBatch {
  dateCreated: string;
  id: string;
  recordVersion: string;
  purchaseOrderId: string;
  quoteItemBatchId: string;
  sortOrder: number;
  description: string | null;
  deliveryDate: string | null;
  customerRef: string | null;
  comment: string | null;
  status: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemCustomerRef: string | null;
  supplierSystemStatus: string | null;
  supplierSystemLastModifiedDate: string | null;
}

export interface PurchaseOrderBatchInfo {
  quoteItemBatchId: string;
  description: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemCustomerRef: string | null;
  supplierSystemStatus: string | null;
}

export interface PurchaseOrderBatchInput {
  quoteItemBatchId: string;
  description: string | null;
  deliveryDate: string | null;
  customerRef: string | null;
  comment: string | null;
  status: string | null;
  sortOrder: number;
}

export interface PurchaseOrderBranchView {
  dateCreated: string;
  id: string;
  recordVersion: string;
  title: string;
  purchaseOrderNumber: number;
  branchQuoteId: string;
  state: PurchaseOrderState;
  description: string;
  installationDate: string | null;
  supplierSystemLastModifiedDate: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemClosedDate: string | null;
  supplierSystemStatus: string | null;
  supplierSystemShippingLeadTime: number | null;
  creationUserId: string;
  lastModifiedUserId: string;
  lastModifiedDate: string | null;
  reference: string;
  customPurchaseOrderNumber: string | null;
  supplierId: string;
  calculatedNetTotal: number;
  calculatedAdjustmentTotal: number;
  branchId: string;
  assignedToUserId: string;
  purchaseOrderCurrency: CurrencyCode;
}

export interface PurchaseOrderBranchViewResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: PurchaseOrderBranchView[];
}

export interface PurchaseOrderDTO {
  id: string;
  branchId: string;
  quoteId: string;
  title: string;
  purchaseOrderNumber: number;
  reference: string;
  state: number;
  installationDate: string | null;
  calculatedNettTotal: number;
  supplierSystemClosedDate: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemStatus: string | null;
  calculatedAdjustmentTotal: number;
  recordVersion: string;
  assignedToUserId: string;
  creationUserId: string;
  lastModifiedUserId: string;
  dateCreated: string | null;
  lastModifiedDate: string | null;
  lastStateChangeDate: string | null;
  purchaseOrderCurrency: number;
}

export enum PurchaseOrderFinalStateReason {
  None = 0,
  Errors = 1,
  Deadline = 2,
  Other = 4
}

export interface PurchaseOrderHistoryState {
  state: PurchaseOrderState;
  numberOfDaysHistory: number | null;
}

export interface PurchaseOrderItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  purchaseOrderId: string;
  quoteItemId: string;
  quoteItemBatchId: string | null;
  quoteItemBatchPosition: number | null;
  supplierSystemStatus: string | null;
  supplierSystemDeliveryDate: string | null;
  supplierSystemBatchId: string | null;
  supplierSystemLastModifiedDate: string | null;
}

export interface PurchaseOrderItemInfo {
  quoteItemId: string;
  supplierSystemStatus: string | null;
  supplierSystemBatchId: string | null;
  supplierSystemDeliveryDate: string | null;
}

export enum PurchaseOrderItemSource {
  Supplier = 1,
  External = 2
}

export interface PurchaseOrderQuoteInfo {
  purchaseOrderId: string;
  quoteId: string;
}

export interface PurchaseOrderResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: PurchaseOrder[];
}

export enum PurchaseOrderState {
  None = 0,
  Draft = 1,
  Issued = 2,
  Completed = 4,
  Cancelled = 8,
  IssuedPending = 16
}

export interface PurchaseOrderStateAudit {
  dateCreated: string;
  id: string;
  recordVersion: string;
  state: PurchaseOrderState;
  dateModified: string;
  purchaseOrderId: string;
  systemUserId: string;
  finalStateReason: PurchaseOrderFinalStateReason;
  comment: string | null;
}

export interface PurchaseOrderSummaryView {
  id: string;
  recordVersion: string;
  purchaseOrderNumber: number;
  title: string;
  state: FabricationPurchaseOrderState;
  itemCount: number;
  linkedJobCount: number;
  dateCreated: string;
  lastModifiedDate: string | null;
  assignedToUserId: string;
  quoteCommonId: string | null;
}

export interface PurchaseOrderSummaryViewResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: PurchaseOrderSummaryView[];
}

export interface PurchaseOrderSupplierInfo {
  purchaseOrderId: string;
  reference: string;
  supplierSystemDeliveryDate: string | null;
  supplierSystemClosedDate: string | null;
  supplierSystemNotesToDealer: string | null;
  supplierSystemStatus: string | null;
  supplierSystemShippingLeadTime: number | null;
  batches: PurchaseOrderBatchInfo[];
  items: PurchaseOrderItemInfo[];
}

export interface Quote {
  dateCreated: string;
  id: string;
  recordVersion: string;
  quoteSetId: string;
  quoteOwnerId: string;
  quoteCustomerId: string;
  quoteNumber: number;
  quoteSuffix: string;
  alternativeType: QuoteAlternativeType;
  title: string;
  state: QuoteState;
  quoteType: QuoteType;
  budget: number | null;
  description: string;
  termsAndConditions: string | null;
  validUntilDate: string | null;
  installationDate: string | null;
  creationUserId: string;
  lastModifiedUserId: string;
  lastModifiedDate: string | null;
  supplierId: string;
  supplierApproved: boolean;
  supplierAuthorizedToIssueOrderOnQuoteApproval: boolean;
  serviceProvider: string;
  serviceProviderData: string | null;
  assetVirtualPaths: { [key: string]: AssetVirtualPathInfo };
  shippingAddress: Address | null;
  shippingNotes: string | null;
  customQuoteNumber: string | null;
  assignedToUserId: string;
  allowNonTaxableItems: boolean | null;
  isShippingTaxable: boolean;
  quoteCurrency: CurrencyCode;
  ssiDeferred: boolean;
}

export enum QuoteAlternativeType {
  Standard = 0,
  SupplierReview = 1
}

export interface QuoteDTO {
  id: string;
  quoteSetId: string;
  branchId: string;
  title: string;
  state: number;
  quoteType: number;
  quoteNumber: number;
  quoteSuffix: string;
  dateCreated: string;
  lastModifiedDate: string;
  lastModifiedUserId: string;
  creationUserId: string;
  validUntilDate: string | null;
  installationDate: string | null;
  recordVersion: string;
  calculatedNetTotal: number;
  assignedToUserId: string;
  isPrimaryQuote: boolean;
  lastStateChangeDate: string | null;
  quoteCurrency: number;
}

export interface QuoteFabricationCountView {
  quoteId: string;
  fabricationStatus: QuoteItemFabricationStatus;
  fabricationJobState: FabricationJobState | null;
  count: number;
}

export enum QuoteFinalStateReason {
  None = 0,
  Price = 1,
  Deadline = 2,
  ProductNotSuitable = 4,
  CompetitorWin = 8,
  UnresponsiveClient = 16,
  IndecisiveClient = 32,
  UnhappyClient = 64,
  DifficultClient = 128,
  Superseded = 256,
  Other = 512
}

export interface QuoteHistoryState {
  state: QuoteState[];
  numberOfDaysHistory: number | null;
}

export interface QuoteItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  quoteId: string;
  commonId: string;
  readonly itemType: QuoteItemType;
  title: string;
  description: string;
  quantity: number;
  comment: string | null;
  commentToManufacturer: string | null;
  providerReferenceId: string;
  serviceProvider: string;
  readonly isShippingItem: boolean;
  quoteItemContentType: number;
  virtualThumbnailPath: string;
  isRestrictedToPowerUser: boolean;
  lastModifiedDate: string;
  lastModifiedUserId: string | null;
  state: QuoteItemState;
}

export interface QuoteItemBatch {
  dateCreated: string;
  id: string;
  recordVersion: string;
  quoteId: string;
  commonId: string;
  description: string;
  excludeFromPricing: boolean;
  deliveryDate: string | null;
  customerRef: string | null;
  status: string | null;
  comment: string | null;
  isPrimary: boolean;
}

export interface QuoteItemBatchInput {
  commonId: string;
  description: string;
  excludeFromPricing: boolean;
  deliveryDate: string | null;
  customerRef: string | null;
  status: string | null;
  comment: string | null;
  isPrimary: boolean;
}

export interface QuoteItemBatchLink {
  dateCreated: string;
  id: string;
  recordVersion: string;
  quoteId: string;
  quoteItemCommonId: string;
  quoteItemBatchId: string;
}

export interface QuoteItemBuyInData {
  dateCreated: string;
  id: string;
  recordVersion: string;
  buyInData: string | null;
}

export interface QuoteItemConversation {
  dateCreated: string;
  id: string;
  recordVersion: string;
  quoteId: string;
  quoteItemId: string;
  conversationId: string;
  type: QuoteItemConversationType;
}

export enum QuoteItemConversationType {
  None = 0,
  EngineeredToOrder = 1
}

export enum QuoteItemFabricationStatus {
  None = 0,
  ReadyForFabrication = 1,
  AssignedToFabricationJob = 2,
  InProduction = 3,
  ReadyForDelivery = 4,
  Delivered = 5
}

export interface QuoteItemFabricationStatusView {
  quoteItemId: string;
  fabricationStatus: QuoteItemFabricationStatus;
  fabricationJobId: string | null;
  fabricationJobNumber: number | null;
  fabricationJobState: FabricationJobState | null;
  factoryTrackingReference: string | null;
  deliveredDate: string | null;
  deliveryNotes: string | null;
  deliveryBatchId: string | null;
}

export interface QuoteItemPrice {
  dateCreated: string;
  id: string;
  recordVersion: string;
  singleUnitCost: number;
  quantityCost: number;
  supplierGrossSingleUnitCost: number;
  supplierGrossQuantityCost: number;
  supplierNettSingleUnitCost: number;
  supplierNettQuantityCost: number;
  supplierPriceAdjustment: number;
  supplierPriceAdjustmentEnabled: boolean;
  supplierPriceAdjustmentReason: string | null;
  percentMarginOrMarkup: number | null;
  priceAdjustment: number;
  calculatedNetSellingPrice: number;
  calculatedGrossSellingPrice: number;
  sourceData: { [key: string]: number };
  breakdowns: QuoteItemPriceBreakdown[] | null;
  requiresRepricing: boolean;
  isTaxableItem: boolean;
}

export interface QuoteItemPriceBreakdown {
  name: string;
  unitPrice: number;
  subType: number;
  sourceData: { [key: string]: number };
  singleUnitCost: number;
  quantityCost: number;
  supplierGrossSingleUnitCost: number;
  supplierGrossQuantityCost: number;
  supplierNettSingleUnitCost: number;
  supplierNettQuantityCost: number;
  calculatedNetSellingPrice: number;
  calculatedGrossSellingPrice: number;
}

export interface QuoteItemProviderData {
  dateCreated: string;
  id: string;
  recordVersion: string;
  providerData: string | null;
  assetVirtualPaths: { [key: string]: AssetVirtualPathInfo };
  lastModifiedDate: string;
  lastModifiedUserId: string | null;
}

export interface QuoteItemQuoteNumberView {
  quoteItemId: string;
  quoteId: string;
  quoteNumber: number;
  itemNumber: number;
}

export enum QuoteItemRowAction {
  Insert = 0,
  Update = 1,
  Delete = 2,
  Undelete = 3,
  HardDelete = 4
}

export enum QuoteItemState {
  None = 0,
  Active = 1,
  Deleted = 2,
  Archived = 4,
  ExcludeFromPricing = 8
}

export enum QuoteItemType {
  None = 0,
  Basic = 1,
  Provider = 2
}

export enum QuoteLockState {
  None = 0,
  Locked = 1,
  Copying = 2,
  Deleting = 3
}

export interface QuotePresentation {
  dateCreated: string;
  id: string;
  recordVersion: string;
  itemDisplayOrder: string[];
}

export interface QuotePrice {
  dateCreated: string;
  id: string;
  recordVersion: string;
  percentMarginOrMarkup: number;
  calculation: QuotePriceCalculation;
  taxPercentage: number;
  priceAdjustment: number;
  calculatedLineItemTotal: number;
  calculatedNetTotal: number;
  calculatedTaxAmount: number;
  calculatedGrossTotal: number;
}

export enum QuotePriceCalculation {
  Margin = 1,
  Markup = 2
}

export interface QuoteReportOptionOverrides {
  coverPage: boolean | null;
  infoPage: boolean | null;
  globalSpecifications: boolean | null;
  itemSummary: boolean | null;
  quoteCalculations: boolean | null;
  itemDetails: boolean | null;
  annotations: boolean | null;
  dealerTerms: boolean | null;
  supplierTerms: boolean | null;
  lineItemPrice: boolean | null;
  groupTotals: boolean | null;
  priceSummary: ReportPriceSummary | null;
  dimensions: boolean | null;
  manufacturerNotes: boolean | null;
  initialsPanel: boolean | null;
  itemSummaryLayout: ItemSummaryLayout | null;
}

export interface QuoteSetSibling {
  quoteId: string;
  quoteSetId: string;
  state: QuoteState;
  alternativeType: QuoteAlternativeType;
  quoteNumber: number;
  quoteSuffix: string;
  supplierApproved: boolean;
  recordVersion: string;
}

export enum QuoteState {
  None = 0,
  Draft = 1,
  Active = 2,
  Issued = 4,
  Accepted = 8,
  Rejected = 16,
  Lapsed = 32,
  Cancelled = 64,
  IssuePending = 128,
  SupplierReviewPending = 256,
  SupplierReviewed = 512,
  Approved = 1024,
  Accepted_RefusedBySupplier = 2048,
  Accepted_AssignedToReviewer = 4096,
  Copying = 8192,
  Deleted = 16384,
  ResetInProgress = 32768
}

export interface QuoteStateAudit {
  dateCreated: string;
  id: string;
  recordVersion: string;
  quoteId: string;
  state: QuoteState;
  dateModified: string;
  systemUserId: string;
  finalStateReason: QuoteFinalStateReason;
  comment: string | null;
}

export enum QuoteType {
  None = 0,
  Estimate = 1,
  Quote = 2,
  Display = 4,
  Warranty = 8
}

export enum ReportPriceSummary {
  None = 0,
  DealerCost = 1,
  Summary = 2
}

export interface RequestBrowseClientSummary {
  clientOwnerId: string | null;
  filterActive: boolean | null;
  filter: string | null;
  pageSize: number;
  pageIndex: number;
  sortField: string | null;
  sortAsc: boolean;
}

export interface RequestBrowseContactSummary {
  clientOwnerId: string | null;
  clientId: string | null;
  filter: string | null;
  pageSize: number;
  pageIndex: number;
  sortField: string | null;
  sortAsc: boolean;
}

export interface RequestBrowsePaymentProfileSummary {
  filter: string | null;
  requestPage: RequestPaginated | null;
  supplierId: string | null;
  branchId: string;
  sortField: string | null;
  sortAsc: boolean;
}

export interface RequestBrowseProjectSummary {
  statesToLoad: ProjectState;
  filter: string | null;
  createdById: string | null;
  pageSize: number;
  pageIndex: number;
  sortField: string | null;
  sortAsc: boolean;
  projectOwnerId: string;
  clientId: string | null;
}

export interface RequestBrowseTermsAndConditionsSummary {
  filter: string | null;
  requestPage: RequestPaginated | null;
  supplierId: string | null;
  branchId: string;
  sortField: string | null;
  sortAsc: boolean;
}

export interface RequestConversation {
  maxRecordVersion: string | null;
  conversationId: string;
  sortAscending: boolean;
  fetchUpdatesOnly: boolean;
}

export interface RequestGetAllLinkedQuoteItemsForConversation {
  conversationId: string;
}

export interface RequestGetAllUserProfileOfTenant {}

export interface RequestGetBranch {
  franchiseeId: string;
  branchId: string;
}

export interface RequestGetBranchInboxItems {
  branchId: string;
}

export interface RequestGetBranchQuoteDefaults {
  branchId: string;
  systemUserId: string;
  supplierId: string;
}

export interface RequestGetBranchQuoteSupport {
  quoteSetId: string;
  quoteId: string | null;
  branchQuoteSupportId: string | null;
}

export interface RequestGetBranchQuoteSupportInbox {
  requestPage: RequestPaginated;
  ticketOwnerId: string | null;
  typeFilter: BranchQuoteSupportItemType;
  statusFilter: BranchQuoteSupportStatus;
  filter: string | null;
  sortField: string | null;
  sortAsc: boolean;
  branchId: string;
}

export interface RequestGetBranchQuotes {
  branchQuoteIds: string[];
}

export interface RequestGetBranches {}

export interface RequestGetClient {
  clientId: string;
}

export interface RequestGetClientDefaultPaymentProfileById {
  clientId: string;
}

export interface RequestGetClientDefaultPaymentProfileListByIds {
  paymentProfileIds: string[];
}

export interface RequestGetClientDefaultPaymentType {
  clientId: string;
}

export interface RequestGetClientDefaultTermsAndConditions {
  clientId: string;
}

export interface RequestGetClientDefaultTermsAndConditionsById {
  clientId: string;
}

export interface RequestGetClientDefaultTermsAndConditionsListByIds {
  termsAndConditionsIds: string[];
}

export interface RequestGetClientListByIds {
  clientIds: string[];
}

export interface RequestGetClientPrimaryContactByIds {
  clientIds: string[];
}

export interface RequestGetClientSummary {
  clientId: string;
}

export interface RequestGetContact {
  contactId: string;
}

export interface RequestGetContactListByIds {
  contactIds: string[];
}

export interface RequestGetDefaultTermsAndConditions {
  branchId: string;
}

export interface RequestGetDeploymentSuppliers {
  dealerDeploymentId: number;
}

export interface RequestGetFabricationJob {
  id: string;
}

export interface RequestGetFabricationJobSummary {
  branchId: string;
  states: FabricationJobState[];
  pageIndex: number;
  pageSize: number;
  searchTerm: string | null;
}

export interface RequestGetFabricationJobTotalsByState {
  branchId: string;
}

export interface RequestGetFabricationJobsByIds {
  fabricationJobIds: string[];
}

export interface RequestGetFabricationPurchaseOrder {
  id: string;
}

export interface RequestGetFabricationPurchaseOrderTotalsByState {
  branchId: string;
}

export interface RequestGetFranchisee {}

export interface RequestGetFranchiseeClientListByIds {
  clientIds: string[];
}

export interface RequestGetFranchiseeConfiguration {}

export interface RequestGetGeneratedPurchaseOrderRevenue {
  startDate: string;
  endDate: string;
  branchId: string;
  userId: string;
  purchaseOrderStates: number[];
}

export interface RequestGetGuids {
  count: number;
}

export interface RequestGetIssuedQuoteRevenue {
  startDate: string;
  endDate: string;
  quoteOwnerId: string;
  userId: string;
  quoteStates: number[];
}

export interface RequestGetNewPurchaseOrdersForSupplier {
  tenantId: number;
  supplierId: string;
  deploymentId: number;
  fromRecordVersion: string;
}

export interface RequestGetNewQuotesForSupplier {
  quoteOwnerFilter: string[];
  supplierId: string;
  deploymentId: number;
  fromRecordVersion: string;
}

export interface RequestGetOptimizationContext {
  quoteItemIds: string[];
}

export interface RequestGetOptimizationResult {
  fabricationJobId: string;
}

export interface RequestGetPaymentProfile {
  paymentProfileId: string;
}

export interface RequestGetPermanentProjectDocuments {
  projectIds: string[];
}

export interface RequestGetProject {
  projectId: string;
}

export interface RequestGetProjectDocument {
  id: string;
}

export interface RequestGetProjectDocuments {
  projectId: string;
}

export interface RequestGetProjectResource {
  projectId: string;
  resourceType: ResourceType;
  pageSize: number;
  pageIndex: number;
}

export interface RequestGetProjectSummaryListByIds {
  projectIds: string[];
}

export interface RequestGetPurchaseOrder {
  purchaseOrderId: string;
}

export interface RequestGetPurchaseOrderDeliveryPipeline {
  pageIndex: number;
  pageSize: number;
  purchaseOrderOwnerId: string | null;
  assignedToUserId: string | null;
  startDate: string | null;
  endDate: string | null;
}

export interface RequestGetPurchaseOrderStateAudit {
  purchaseOrderId: string;
  state: PurchaseOrderState | null;
}

export interface RequestGetPurchaseOrderSummary {
  branchId: string;
  states: FabricationPurchaseOrderState[];
  pageIndex: number;
  pageSize: number;
  searchTerm: string | null;
  excludeLineSetLocked: boolean;
}

export interface RequestGetPurchaseOrderTotalsByState {
  ownerId: string;
  options: PurchaseOrderHistoryState[];
}

export interface RequestGetPurchaseOrderUserIdsByBranchId {
  branchId: string;
}

export interface RequestGetPurchaseOrderUserIdsByBranchIds {
  branchIds: string[];
}

export interface RequestGetPurchaseOrders {
  purchaseOrderOwnerId: string | null;
  statesToLoad: PurchaseOrderState;
  filter: string | null;
  pageSize: number;
  pageIndex: number;
  sortField: string | null;
  sortAsc: boolean;
  createdById: string | null;
  numberOfDaysHistory: number | null;
}

export interface RequestGetPurchaseOrdersById {
  purchaseOrderIds: string[];
}

export interface RequestGetPurchaseOrdersByIds {
  purchaseOrderIds: string[];
}

export interface RequestGetPurchaseOrdersForJob {
  fabricationJobId: string;
}

export interface RequestGetPurchaseOrdersForJobs {
  fabricationJobIds: string[];
}

export interface RequestGetQuote {
  quoteId: string;
}

export interface RequestGetQuoteFabricationSummaries {
  quoteIds: string[];
}

export interface RequestGetQuoteItem {
  quoteItemId: number;
}

export interface RequestGetQuoteItemBatches {
  quoteId: string;
}

export interface RequestGetQuoteItemFabricationStatuses {
  quoteItemIds: string[];
}

export interface RequestGetQuoteItemPrice {
  quoteItemId: number;
}

export interface RequestGetQuoteItemsProviderData {
  quoteId: string;
  quoteItemIds: string[];
}

export interface RequestGetQuoteItemsSummary {
  quoteId: string;
  includeAllStates: boolean | null;
}

export interface RequestGetQuoteItemsSummaryById {
  quoteItemId: string[];
}

export interface RequestGetQuoteNumbersByQuoteItemIds {
  quoteItemIds: string[];
}

export interface RequestGetQuotePrice {
  quoteId: string;
}

export interface RequestGetQuoteSetSummary {
  quoteOwnerId: string;
  quoteSetId: string;
}

export interface RequestGetQuoteStateAudit {
  quoteId: string;
  state: QuoteState | null;
}

export interface RequestGetQuoteSummary {
  quoteOwnerId: string;
  statesToLoad: QuoteState[];
  numberOfDaysHistory: number | null;
  title: string | null;
  description: string | null;
  pageSize: number;
  pageIndex: number;
  sortField: string | null;
  sortAsc: boolean;
  assignedToUserId: string | null;
}

export interface RequestGetQuoteSummaryListByIds {
  quoteIds: string[];
}

export interface RequestGetQuoteTotalsByState {
  quoteOwnerId: string[];
  options: QuoteHistoryState[];
}

export interface RequestGetQuoteUserIdsByOwnerId {
  ownerId: string;
}

export interface RequestGetQuoteUserIdsByOwnerIds {
  ownerIds: string[];
}

export interface RequestGetResetTenantPassword {
  userName: string | null;
}

export interface RequestGetResourceLinks {
  resourceIds: string[];
}

export interface RequestGetResourceLocks {
  resourceType: string;
}

export interface RequestGetResourcesListByIds {
  resourceIds: string[];
}

export interface RequestGetStock {
  filter: string | null;
}

export interface RequestGetSupplierApiAccess {
  supplierId: string;
  deploymentId: number;
}

export interface RequestGetSupplierConfiguration {
  supplierId: string;
}

export interface RequestGetSupplierPricingRule {
  supplierId: string;
}

export interface RequestGetSupplierPurchaseOrderRecipients {
  supplierId: string;
}

export interface RequestGetSupplierQuoteSettings {
  supplierId: string;
}

export interface RequestGetSupplierTAC {
  supplierId: string;
}

export interface RequestGetTenantFabricationPurchaseOrdersProcessing {
  tenantId: number;
  supplierId: string;
}

export interface RequestGetTenantPurchaseOrdersProcessing {
  tenantId: number;
  supplierId: string;
}

export interface RequestGetTenants {
  dealerDeploymentId: number;
}

export interface RequestGetTermsAndConditions {
  termsAndConditionsId: string;
}

export interface RequestGetUserProfile {
  systemUserIds: string[] | null;
}

export interface RequestLicenseServerNotify {
  command: string;
  information: { [key: string]: string };
}

export interface RequestLookupStock {
  lookup: LookupStockItem[];
}

export interface RequestPaginated {
  pageSize: number;
  pageIndex: number;
}

export interface RequestSetTenantFabricationPurchaseOrdersProcessing {
  tenantId: number;
  items: FabricationPurchaseOrderSupplierInfo[];
}

export interface RequestSetTenantPurchaseOrdersProcessing {
  tenantId: number;
  items: PurchaseOrderSupplierInfo[];
}

export interface RequestSystemConfiguration {}

export interface ResetTenantMigrationCheckRequest {
  tenantId: number;
}

export interface Resource {
  projectId: string;
  parentResourceId: string;
  parentTypeOf: ResourceType;
  resourceId: string;
  dateCreated: string;
  typeOf: ResourceType;
}

export interface ResourceLink {
  resourceId: string;
  resourceType: ResourceType;
}

export interface ResourceLock {
  id: string;
  purpose: string;
  resourceType: string;
  systemUserId: string;
  sessionLock: string;
  optmisticLock: string;
}

export enum ResourceType {
  None = 0,
  Quote = 1,
  PurchaseOrder = 2,
  Invoice = 4,
  FabricationJob = 8,
  FabricationPurchaseOrder = 16
}

export interface ResultAddBranchInboxItem {
  item: BranchInboxItem;
}

export interface ResultBranchQuoteSupport {
  branchQuoteSupport: BranchQuoteSupport;
  masterDocument: ViewConversationEntry | null;
}

export interface ResultBrowseClientSummary {
  clientSummary: ViewClientSummaryResultPaginated;
}

export interface ResultBrowseContactSummary {
  contactSummary: ViewContactSummaryResultPaginated;
}

export interface ResultBrowsePaymentProfileSummary {
  paymentProfileSummary: PaymentProfileSummaryResultPaginated;
}

export interface ResultBrowseProjectSummary {
  projectSummary: ViewProjectSummaryResultPaginated;
}

export interface ResultBrowseTermsAndConditionsSummary {
  termsAndConditionsSummary: TermsAndConditionsSummaryResultPaginated;
}

export interface ResultCSVProducer {
  data: string;
}

export interface ResultCleanupConversationAttachments {}

export interface ResultCleanupQuoteFabricationData {
  success: boolean;
  blockingItemCount: number;
}

export interface ResultConversation {
  conversationEntries: ViewConversationEntry[];
  maxRecordVersion: string;
}

export interface ResultConversationUploadAttachment {
  success: boolean;
  message: string;
  files: ViewConversationAttachment[];
}

export interface ResultCopyFilesByVirtualPath {}

export interface ResultCreateBranch {
  branch: Branch;
}

export interface ResultCreateBranchQuote {
  branchQuote: BranchQuote | null;
}

export interface ResultCreateBuyIn {}

export interface ResultCreateClient {
  client: Client;
}

export interface ResultCreateContact {
  contact: Contact;
}

export interface ResultCreateFabricationJob {
  fabricationJob: FabricationJob;
}

export interface ResultCreateFranchiseeClient {
  franchiseeClient: FranchiseeClient;
}

export interface ResultCreatePaymentProfile {
  paymentProfile: PaymentProfile | null;
}

export interface ResultCreateProject {
  project: Project;
  resources: Resource[];
  documents: ViewProjectDocument[];
}

export interface ResultCreateProjectDocumentLink {
  projectDocuments: ViewProjectDocument[];
}

export interface ResultCreateProjectResourceReference {
  projectResourceReference: Resource;
}

export interface ResultCreatePurchaseOrder {
  purchaseOrder: PurchaseOrder;
  purchaseOrderItems: PurchaseOrderItem[];
}

export interface ResultCreateQuote {
  quote: Quote;
  quotePrice: QuotePrice;
  quotePresentation: QuotePresentation;
}

export interface ResultCreateQuoteItem {
  quoteItem: QuoteItem;
  quoteItemProviderData: QuoteItemProviderData | null;
  quoteItemBuyInData: string | null;
  quoteItemPrice: QuoteItemPrice;
  resultFullQuotePrice: ResultFullQuotePrice;
  quote: Quote;
  quotePresentation: QuotePresentation;
}

export interface ResultCreateQuoteItemFabrications {
  createdCount: number;
}

export interface ResultCreateTempPurchaseOrderQuote {
  quoteCommonId: string;
}

export interface ResultCreateTermsAndConditions {
  termsAndConditions: TermsAndConditions | null;
}

export interface ResultDealerSystemConfiguration {
  defaultDealerConfiguration: SystemConfiguration;
}

export interface ResultDeleteBranch {}

export interface ResultDeleteBranchQuote {}

export interface ResultDeleteFilesByVirtualPath {}

export interface ResultDeletePaymentProfile {}

export interface ResultDeleteProject {}

export interface ResultDeleteProjectDocument {
  successful: boolean;
}

export interface ResultDeleteProjectResourceReference {}

export interface ResultDeleteQuote {}

export interface ResultDeleteQuoteItem {
  resultFullQuotePrice: ResultFullQuotePrice;
  quotePresentation: QuotePresentation;
  quote: Quote;
  quoteItem: QuoteItem | null;
  quoteItemProviderData: QuoteItemProviderData | null;
  quoteItemBuyInData: string | null;
  quoteItemPrice: QuoteItemPrice | null;
}

export interface ResultDuplicateBranchQuoteSupport {
  branchQuoteSupport: BranchQuoteSupport;
  quoteItemConversation: QuoteItemConversation;
  masterDocument: ViewConversationEntry;
}

export interface ResultDuplicateConversation {}

export interface ResultDuplicateQuote {
  siblings: QuoteSetSibling[];
  source: Quote;
  quote: Quote;
  quotePrice: QuotePrice;
  quotePresentation: QuotePresentation;
}

export interface ResultDuplicateQuoteItem {
  quoteItem: QuoteItem;
  quoteItemPrice: QuoteItemPrice;
  quoteItemProviderData: QuoteItemProviderData | null;
  quoteItemBuyInData: QuoteItemBuyInData | null;
  quotePresentation: QuotePresentation;
  resultFullQuotePrice: ResultFullQuotePrice;
  quote: Quote;
}

export interface ResultFullQuotePrice {
  quotePrice: QuotePrice;
  itemPrices: QuoteItemPrice[];
  itemBuyIns: QuoteItemBuyInData[];
}

export interface ResultGetActiveUserInformation {
  franchisee: Franchisee;
  franchiseeConfiguration: FranchiseeConfiguration;
  taxRates: TaxRate[];
  branches: Branch[];
  defaultBranchId: string;
  userClaims: { [key: string]: string };
}

export interface ResultGetAllLinkedQuoteItemsForConversation {
  quoteItemIds: string[];
}

export interface ResultGetAllUserProfileOfTenant {
  userProfiles: TenantLoginPublicInfo[] | null;
}

export interface ResultGetBranch {
  branch: Branch | null;
}

export interface ResultGetBranchInboxItems {
  items: ViewBranchInboxItem[];
}

export interface ResultGetBranchQuoteDefaults {
  branchQuoteDefaults: BranchQuoteDefaults[];
  branchQuoteDefaultsPrimary: BranchQuoteDefaultsPrimary[];
}

export interface ResultGetBranchQuoteSupport {
  items: BranchQuoteSupport[];
  masterDocuments: ViewConversationEntry[];
  conversationLinks: QuoteItemConversation[];
}

export interface ResultGetBranchQuoteSupportInbox {
  items: ViewBranchQuoteSupportInboxItemResultPaginated;
  conversationLinks: QuoteItemConversation[];
}

export interface ResultGetBranchQuotes {
  branchQuotes: BranchQuote[];
}

export interface ResultGetBranches {
  branches: Branch[];
  branchUsers: { [key: string]: ViewBranchUser[] };
}

export interface ResultGetClient {
  client: Client;
}

export interface ResultGetClientDefaultPaymentProfileById {
  profile: ViewClientDefaultPaymentProfile;
}

export interface ResultGetClientDefaultPaymentProfileListByIds {
  profiles: PaymentProfile[];
}

export interface ResultGetClientDefaultPaymentType {
  paymentProfileSummary: ViewClientDefaultPaymentProfile | null;
}

export interface ResultGetClientDefaultTermsAndConditions {
  termsAndConditions: ViewClientDefaultTermsAndConditions | null;
}

export interface ResultGetClientDefaultTermsAndConditionsById {
  termsAndConditions: ViewClientDefaultTermsAndConditions;
}

export interface ResultGetClientDefaultTermsAndConditionsListByIds {
  termsAndConditionsList: TermsAndConditions[];
}

export interface ResultGetClientListByIds {
  clients: Client[];
}

export interface ResultGetClientPrimaryContactByIds {
  clientPrimaryContacts: ClientPrimaryContact[];
}

export interface ResultGetClientSummary {
  clientSummary: ViewClientSummary;
}

export interface ResultGetConcurrencyCheck {
  recordVersion: string;
}

export interface ResultGetContact {
  contact: Contact;
}

export interface ResultGetContactListByIds {
  contacts: Contact[];
}

export interface ResultGetDeploymentSuppliers {
  items: SupplierData[];
}

export interface ResultGetFabricationJob {
  fabricationJob: FabricationJob;
  items: FabricationJobItem[];
  itemFabrications: QuoteItemFabricationStatusView[];
}

export interface ResultGetFabricationJobTotalsByState {
  stateCounts: FabricationJobStateCount[];
}

export interface ResultGetFabricationPurchaseOrderTotalsByState {
  stateCounts: FabricationPurchaseOrderStateCount[];
}

export interface ResultGetFranchisee {
  franchisee: Franchisee;
}

export interface ResultGetFranchiseeClientListByIds {
  clients: FranchiseeClient[];
}

export interface ResultGetFranchiseeConfiguration {
  franchiseeConfiguration: FranchiseeConfiguration;
  taxRates: TaxRate[];
}

export interface ResultGetGeneratedPurchaseOrderRevenue {
  revenueSummary: ViewDailyRevenueByCurrency[];
  startDate: string;
  endDate: string;
  purchaseOrderStates: number[];
}

export interface ResultGetGuids {
  guids: string[];
}

export interface ResultGetIssuedQuoteRevenue {
  revenueSummary: ViewDailyRevenueByCurrency[];
  startDate: string;
  endDate: string;
  quoteStates: number[];
}

export interface ResultGetNewPurchaseOrdersForSupplier {
  purchaseOrders: PurchaseOrderDTO[];
}

export interface ResultGetNewQuotesForSupplier {
  quotes: QuoteDTO[];
}

export interface ResultGetOptimizationContext {
  supplierId: string;
  items: OptimizationContextItem[];
}

export interface ResultGetOptimizationResult {
  optimizationResult: OptimizationResult | null;
}

export interface ResultGetPaymentProfile {
  paymentProfile: PaymentProfile | null;
}

export interface ResultGetPermanentProjectDocuments {
  documents: ViewProjectPermanentDocuments[];
}

export interface ResultGetProject {
  project: Project;
  resources: Resource[];
  documents: ViewProjectDocument[];
}

export interface ResultGetProjectDocument {
  document: ViewProjectDocument;
}

export interface ResultGetProjectDocuments {
  projectDocuments: ViewProjectDocument[];
}

export interface ResultGetProjectResource {
  projectResourceReference: ViewProjectResourceReferenceResultPaginated;
}

export interface ResultGetProjectSummaryListByIds {
  projectSummaries: ViewProjectSummary[];
}

export interface ResultGetPurchaseOrder {
  purchaseOrder: PurchaseOrderBranchView;
  purchaseOrderItems: PurchaseOrderItem[];
  purchaseOrderBatches: PurchaseOrderBatch[];
}

export interface ResultGetPurchaseOrderDeliveryPipeline {
  purchaseOrdersBranchView: PurchaseOrderBranchViewResultPaginated;
}

export interface ResultGetPurchaseOrderStateAudit {
  purchaseOrderStateAudit: PurchaseOrderStateAudit[];
}

export interface ResultGetPurchaseOrderTotalsByState {
  totals: ViewPurchaseOrderTotalByState[];
}

export interface ResultGetPurchaseOrderUserIdsByBranchId {
  userIds: string[];
}

export interface ResultGetPurchaseOrderUserIdsByBranchIdV1 {
  branchId: string;
  userIds: string[];
}

export interface ResultGetPurchaseOrderUserIdsByBranchIds {
  values: ResultGetPurchaseOrderUserIdsByBranchIdV1[];
}

export interface ResultGetPurchaseOrders {
  purchaseOrders: PurchaseOrderResultPaginated;
}

export interface ResultGetPurchaseOrdersById {
  purchaseOrders: PurchaseOrderBranchView[];
}

export interface ResultGetQuote {
  quote: Quote;
  quotePrice: QuotePrice;
  quotePresentation: QuotePresentation;
  siblings: QuoteSetSibling[];
}

export interface ResultGetQuoteFabricationSummaries {
  counts: QuoteFabricationCountView[];
}

export interface ResultGetQuoteItem {
  quoteItem: QuoteItem;
}

export interface ResultGetQuoteItemBatches {
  batches: QuoteItemBatch[];
}

export interface ResultGetQuoteItemFabricationStatuses {
  statuses: QuoteItemFabricationStatusView[];
}

export interface ResultGetQuoteItemPrice {
  quoteItemPrice: QuoteItemPrice;
}

export interface ResultGetQuoteItemsProviderData {
  data: QuoteItemProviderData[];
}

export interface ResultGetQuoteItemsSummary {
  items: QuoteItem[];
  data: QuoteItemProviderData[];
  prices: QuoteItemPrice[];
  quoteItemBuyInData: QuoteItemBuyInData[];
  batches: QuoteItemBatch[];
  itemBatchLinks: QuoteItemBatchLink[];
}

export interface ResultGetQuoteItemsSummaryById {
  items: QuoteItem[];
  data: QuoteItemProviderData[];
  prices: QuoteItemPrice[];
  quoteItemBuyInData: QuoteItemBuyInData[];
}

export interface ResultGetQuoteNumbersByQuoteItemIds {
  items: QuoteItemQuoteNumberView[];
}

export interface ResultGetQuotePrice {
  quotePrice: QuotePrice;
}

export interface ResultGetQuoteSetSummary {
  quoteSummary: ViewQuoteSummary[];
}

export interface ResultGetQuoteStateAudit {
  quoteStateAudit: QuoteStateAudit[];
}

export interface ResultGetQuoteSummary {
  quoteSummary: ViewQuoteSummaryResultPaginated;
  siblings: QuoteSetSibling[];
}

export interface ResultGetQuoteSummaryListByIds {
  quoteSummaries: ViewQuoteSummary[];
  siblings: QuoteSetSibling[];
}

export interface ResultGetQuoteTotalsByState {
  totals: ViewQuoteTotalByState[];
}

export interface ResultGetQuoteUserIdsByOwnerId {
  userIds: string[];
}

export interface ResultGetQuoteUserIdsByOwnerIdV1 {
  ownerId: string;
  userIds: string[];
}

export interface ResultGetQuoteUserIdsByOwnerIds {
  values: ResultGetQuoteUserIdsByOwnerIdV1[];
}

export interface ResultGetResetTenantPassword {}

export interface ResultGetResourceLinks {
  resourceLinks: ViewResourceLink[];
}

export interface ResultGetResourceLocks {
  items: ResourceLock[];
}

export interface ResultGetResourcesListByIds {
  resources: Resource[];
}

export interface ResultGetStock {
  stockItems: StockItem[];
}

export interface ResultGetSupplierApiAccess {
  supplierHosts: SupplierApiAccess[];
}

export interface ResultGetSupplierConfiguration {
  supplierId: string;
  globalSupplierId: number;
  validityPeriod: number;
  leadPeriod: number;
  allowCustomItemRequest: boolean;
  allowSupportRequest: boolean;
  allowSupplierReview: boolean;
  availableQuoteTypes: QuoteType[];
  purchaseOrderTermsAndConditions: string;
  termsAndConditionsOfUse: string;
  removeWatermarkOnDraft: boolean;
  watermark: WatermarkType;
  willCallLocations: WillCallLocation[] | null;
  quoteItemSummaryConfigurations: SupplierTableConfig[] | null;
  configLastModifiedUtc: string | null;
  resourceLogoVirtualPath: string;
  resourceUrl: string;
  resourceLogoAltText: string;
  quoteReports: SupplierReportSetting[] | null;
}

export interface ResultGetSupplierPricingRule {
  pricingRule: PricingRule;
  pricingRuleType: PricingRuleType;
}

export interface ResultGetSupplierPurchaseOrderRecipients {
  recpientEmails: string[];
}

export interface ResultGetSupplierQuoteSettings {
  supplierId: string;
  globalSupplierId: number;
  validityPeriod: number;
  leadPeriod: number;
  allowCustomItemRequest: boolean;
  allowSupportRequest: boolean;
  allowSupplierReview: boolean;
  availableQuoteTypes: QuoteType[];
  removeWatermarkOnDraft: boolean;
  watermark: WatermarkType;
  willCallLocations: WillCallLocation[] | null;
  quoteItemSummaryConfigurations: SupplierTableConfig[] | null;
  quoteReports: SupplierQuoteReportAvailability[] | null;
}

export interface ResultGetSupplierTAC {
  supplierPurchaseOrderTermsAndConditions: string;
  supplierTermsAndConditionsOfUse: string;
}

export interface ResultGetTenantFabricationPurchaseOrdersProcessing {
  tenantId: number;
  supplierId: string;
  info: FabricationPurchaseOrderQuoteInfo[];
}

export interface ResultGetTenantPurchaseOrdersProcessing {
  tenantId: number;
  supplierId: string;
  info: PurchaseOrderQuoteInfo[];
}

export interface ResultGetTenants {
  tenants: TenantData[];
}

export interface ResultGetTermsAndConditions {
  termsAndConditions: TermsAndConditions | null;
}

export interface ResultGetUserProfile {
  userProfiles: TenantLoginPublicInfo[] | null;
}

export interface ResultLapseQuotes {
  lapsedQuotes: string[];
}

export interface ResultLicenseServerNotify {}

export interface ResultLockResource {
  lock: ResourceLock;
}

export interface ResultLockResources {
  locks: ResourceLock[];
}

export interface ResultLookupStock {
  stockItems: StockLookupView[];
}

export interface ResultOptimizationMutation {
  optimizationResult: OptimizationResult | null;
  projectIds: string[];
}

export interface ResultPurchaseOrder {
  purchaseOrder: FabricationPurchaseOrder;
  items: FabricationPurchaseOrderItem[];
  linkedJobIds: string[];
  quoteCommonIdWasMinted: boolean;
}

export interface ResultQueueCleanupConversationAttachments {}

export interface ResultQuoteCleanupDeletedItems {}

export interface ResultQuoteItem {
  quoteItem: QuoteItem | null;
  quoteItemProviderData: QuoteItemProviderData | null;
  quoteItemBuyInData: string | null;
  quoteItemPrice: QuoteItemPrice | null;
}

export interface ResultQuoteItemConversations {
  items: QuoteItemConversation[];
}

export interface ResultRecordQuoteItemDelivery {
  statuses: QuoteItemFabricationStatusView[];
}

export interface ResultRegisterFabricationJobOnProject {
  resourceCreated: boolean;
  documentCreated: boolean;
}

export interface ResultReleaseCopyLock {}

export interface ResultResolveBranchQuoteSupport {}

export interface ResultSetQuoteAssignedToUser {}

export interface ResultSetQuoteItemFactoryTrackingReference {
  status: QuoteItemFabricationStatusView;
}

export interface ResultSetTenantFabricationPurchaseOrdersProcessing {}

export interface ResultSetTenantPurchaseOrdersProcessing {}

export interface ResultUnLockResource {
  lock: ResourceLock;
}

export interface ResultUnLockResources {
  locks: ResourceLock[];
}

export interface ResultUnregisterFabricationJobFromProject {
  documentsDeleted: number;
  resourceDeleted: boolean;
}

export interface ResultUpdateBranch {
  branch: Branch | null;
}

export interface ResultUpdateBranchQuote {
  branchQuote: BranchQuote | null;
}

export interface ResultUpdateBranchQuoteDefaults {
  branchQuoteDefaults: BranchQuoteDefaults[];
  branchQuoteDefaultsPrimary: BranchQuoteDefaultsPrimary[];
}

export interface ResultUpdateClient {
  client: Client;
}

export interface ResultUpdateContact {
  contact: Contact;
}

export interface ResultUpdateFabricationJob {
  fabricationJob: FabricationJob;
  projectIds: string[];
}

export interface ResultUpdateFabricatorRateOverrides {
  overrides: LaborRateOverrides;
}

export interface ResultUpdateFileByVirtualPath {
  virtualPath: string | null;
  eTag: string | null;
  lastModified: string | null;
  contentType: string | null;
  contentLength: number | null;
}

export interface ResultUpdateFranchisee {
  franchisee: Franchisee;
}

export interface ResultUpdateFranchiseeClient {
  franchiseeClient: FranchiseeClient | null;
}

export interface ResultUpdateFranchiseeConfiguration {
  franchiseeConfiguration: FranchiseeConfiguration;
  taxRates: TaxRate[];
}

export interface ResultUpdateFranchiseeProperties {
  properties: { [key: string]: string };
}

export interface ResultUpdatePaymentProfile {
  paymentProfile: PaymentProfile | null;
}

export interface ResultUpdateProject {
  project: Project;
  resources: Resource[];
  documents: ViewProjectDocument[];
}

export interface ResultUpdateProjectDocumentLink {
  projectDocuments: ViewProjectDocument[];
}

export interface ResultUpdatePurchaseOrder {
  purchaseOrder: PurchaseOrder;
  purchaseOrderItems: PurchaseOrderItem[];
}

export interface ResultUpdateQuote {
  quote: Quote | null;
  resultFullQuotePrice: ResultFullQuotePrice | null;
  siblings: QuoteSetSibling[] | null;
  quotePresentation: QuotePresentation | null;
}

export interface ResultUpdateQuoteItem {
  quoteItem: QuoteItem | null;
  quoteItemProviderData: QuoteItemProviderData | null;
  quoteItemBuyInData: string | null;
  quoteItemPrice: QuoteItemPrice | null;
  resultFullQuotePrice: ResultFullQuotePrice | null;
  quote: Quote;
}

export interface ResultUpdateQuoteItems {
  resultFullQuotePrice: ResultFullQuotePrice | null;
  quote: Quote;
  quotePresentation: QuotePresentation | null;
  items: ResultQuoteItem[];
}

export interface ResultUpdateQuotePrice {
  quote: Quote | null;
  resultFullQuotePrice: ResultFullQuotePrice | null;
  siblings: QuoteSetSibling[] | null;
  quotePresentation: QuotePresentation | null;
  updatedQuoteItems: QuoteItem[];
}

export interface ResultUpdateQuoteSetState {
  items: QuoteSetSibling[];
}

export interface ResultUpdateStock {
  stockItems: StockItem[];
}

export interface ResultUpdateTermsAndConditions {
  termsAndConditions: TermsAndConditions | null;
}

export interface ResultVerifyUser {
  claims: { [key: string]: string } | null;
}

export interface ResultVoid {}

export interface StockItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  code: string;
  description: string;
  singleUnitCost: number | null;
  itemContentType: number;
  stockCategoryId: string;
}

export interface StockLookupView {
  code: string;
  supplierId: string;
  libCode: string;
  supplierCode: string;
  cost: number | null;
  description: string;
  version: string;
}

export interface SupplierApiAccess {
  host: string | null;
  serverToServerToken: string | null;
  tenantId: number;
  globalSupplierId: number;
  dealerDeploymentId: number;
  uiDomain: string | null;
}

export interface SupplierData {
  id: number;
  name: string;
  supplierId: string;
}

export interface SupplierQuoteReportAvailability {
  report: DealerReport;
  enabled: boolean;
}

export interface SupplierReportSetting {
  report: DealerReport;
  enabled: boolean | null;
  storedOnIssue: boolean | null;
  options: QuoteReportOptionOverrides | null;
}

export interface SupplierTableConfig {
  code: string;
  title: string;
  systemDefault: boolean;
  defaultDisplay: boolean;
  canSwitch: boolean;
}

export interface SupportQuoteItemLinkDetail {
  id: string;
  textDisplay: string;
  isLinked: boolean;
}

export interface SystemConfiguration {
  quoteItemColumnConfigurations: TableColumnConfiguration[];
}

export interface TableColumnConfiguration {
  code: string;
  title: string;
  systemDefault: boolean;
  defaultDisplay: boolean;
  canSwitch: boolean;
}

export interface TaxRate {
  dateCreated: string;
  id: string;
  recordVersion: string;
  franchiseeId: string;
  name: string;
  rate: number;
  position: number;
  dateModified: string;
  modifiedUserId: string;
}

export interface TenantData {
  id: number;
  name: string;
  suppliers: string[];
}

export interface TenantLoginPublicInfo {
  id: string;
  tenantId: number;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  jobTitle: string | null;
  phone: string | null;
  isActive: boolean | null;
}

export interface TermsAndConditions {
  dateCreated: string;
  id: string;
  recordVersion: string;
  franchiseeId: string;
  branchId: string;
  name: string;
  terms: string | null;
  isDefault: boolean;
  supplierId: string;
}

export interface TermsAndConditionsSummary {
  id: string;
  name: string;
  supplierId: string;
  isDefault: boolean;
}

export interface TermsAndConditionsSummaryResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: TermsAndConditionsSummary[];
}

export enum TestExceptionType {
  Generic = 0,
  Authentication = 1,
  Authorization = 2,
  AlreadyConnected = 3,
  MigrationError = 4,
  RetryLimitExceeded = 5,
  Validation = 6,
  ModifyNotFound = 7,
  ServiceResponse = 8,
  HttpRequest = 9,
  DeeplyNested = 10,
  Aggregate = 11
}

export interface TestPingResponse {
  message: string;
  timestamp: string;
}

export interface UINavigation {
  id: string;
  itemType: string;
}

export interface UnitOptionOverride {
  unitIndex: number;
  v6QuoteItemVirtualPath: string | null;
  bomVirtualPath: string | null;
}

export interface UpdateQuoteItem {
  action: QuoteItemRowAction;
  input: InputUpdateQuoteItem;
}

export interface ViewBranchInboxItem {
  dateCreated: string;
  id: string;
  recordVersion: string;
  subject: string;
  branchId: string;
  message: string;
  attachments: BranchInboxAttachments;
  navigation: BranchInboxNavigation;
  state: BranchInboxItemState;
}

export interface ViewBranchQuoteSupportInboxItem {
  subject: string;
  branchQuoteId: string;
  requestType: BranchQuoteSupportItemType;
  status: BranchQuoteSupportStatus;
  createdUserId: string;
  dateCreated: string;
  lastModifiedUserId: string;
  lastModified: string;
  conversationId: string;
  quoteTitle: string;
  quoteNumber: number;
  quoteSuffix: string;
  quoteType: number;
  clientName: string;
}

export interface ViewBranchQuoteSupportInboxItemResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewBranchQuoteSupportInboxItem[];
}

export interface ViewBranchUser {
  userId: string;
  isActive: boolean;
}

export interface ViewClientDefaultPaymentProfile {
  clientId: string;
  profileId: string;
  name: string;
}

export interface ViewClientDefaultTermsAndConditions {
  clientId: string;
  termsAndConditionsId: string;
  name: string;
}

export interface ViewClientSummary {
  id: string;
  clientOwnerId: string;
  name: string;
  primaryContactId: string | null;
  primaryContactName: string | null;
  primaryContactEmail: string | null;
  physicalAddress: Address | null;
}

export interface ViewClientSummaryResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewClientSummary[];
}

export interface ViewContactSummary {
  id: string;
  name: string;
  isPrimary: boolean;
  title: string;
  email: string;
  mobile: string | null;
  clientId: string;
  clientName: string;
}

export interface ViewContactSummaryResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewContactSummary[];
}

export interface ViewConversationAttachment {
  filename: string;
  virtualPath: string;
  publicUrl: string;
  size: number;
  embedded: boolean;
}

export interface ViewConversationEntry {
  id: string;
  franchiseeId: string;
  conversationId: string;
  dateCreated: string;
  lastModified: string;
  editCount: number;
  systemUserId: string;
  text: string;
  attachments: ViewConversationAttachment[];
  users: string[];
  draft: boolean;
}

export interface ViewDailyRevenueByCurrency {
  count: number;
  date: string;
  state: number;
  dailyRevenue: number;
  currency: CurrencyCode;
}

export interface ViewProjectDocument {
  documentTracker: DocumentTracker;
  publicFileURL: string;
}

export interface ViewProjectPermanentDocuments {
  projectId: string;
  projectDocuments: ViewProjectDocument[];
}

export interface ViewProjectResourceReference {
  projectId: string;
  resourceId: string;
  typeOf: ResourceType;
  parentResourceId: string;
  parentTypeOf: ResourceType;
}

export interface ViewProjectResourceReferenceResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewProjectResourceReference[];
}

export interface ViewProjectSummary {
  id: string;
  title: string;
  number: number;
  clientId: string;
  state: ProjectState;
  dateCreated: string;
  creationUserId: string;
  lastModifiedDate: string;
  assignedToUserId: string;
  installationAddress: Address | null;
}

export interface ViewProjectSummaryResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewProjectSummary[];
}

export interface ViewPurchaseOrderTotalByState {
  ownerId: string;
  state: PurchaseOrderState;
  userId: string;
  total: number;
  count: number;
}

export interface ViewQuoteSummary {
  supplierId: string;
  id: string;
  title: string;
  dateCreated: string;
  creationUserId: string;
  lastModifiedDate: string | null;
  lastModifiedUserId: string;
  assignedToUserId: string;
  description: string;
  quoteOwnerId: string;
  quoteCustomerId: string;
  calculation: QuotePriceCalculation;
  percentMarginOrMarkup: number;
  calculatedGrossTotal: number;
  calculatedNetTotal: number;
  calculatedTaxAmount: number;
  quoteNumber: number;
  quoteSuffix: string;
  state: QuoteState;
  quoteType: QuoteType;
  quoteCurrency: CurrencyCode;
  recordVersion: string;
  quoteSetId: string;
  supplierApproved: boolean;
  lockState: QuoteLockState;
  lockOwnerId: string;
}

export interface ViewQuoteSummaryResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewQuoteSummary[];
}

export interface ViewQuoteTotalByState {
  quoteOwnerId: string;
  total: number;
  userId: string;
  quoteState: QuoteState[];
  currency: CurrencyCode;
  quoteCount: number;
}

export interface ViewResourceLink {
  projectId: string;
  resourceType: ResourceType;
  resourceId: string;
  parent: ResourceLink | null;
  childResources: ResourceLink[];
}

export enum WatermarkType {
  DraftInternalRed = 0,
  DraftInternal = 1,
  InternalUse = 2,
  Draft = 4,
  DraftVersion = 8
}

export interface WillCallAddress {
  line1: string;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  locality: string | null;
  region: string | null;
  postcode: string;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  source: string | null;
}

export interface WillCallLocation {
  id: string;
  title: string;
  type: string;
  willCallAddress: WillCallAddress;
}
